"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.omit")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _button = require("../styles/button"),
    OMITTED_PROPS = ["className", "busy", "disabled", "small"],
    TYPE_STYLES_MAP = {
  PRIMARY: _button.PRIMARY,
  SECONDARY: _button.SECONDARY,
  INVERTED: _button.INVERTED
};

function Button(a) {
  var b,
      c = a.disabled,
      d = a.className,
      e = a.busy,
      f = a.children,
      g = a.type,
      h = void 0 === g ? "PRIMARY" : g,
      i = a.small,
      j = a.invertedDisabled,
      k = a.prefix,
      l = "string" == typeof k ? _react["default"].createElement(_Icon["default"], {
    key: "prefix-icon",
    className: _button.ICON,
    name: k,
    color: _button.COLORS_MAP[h],
    size: i ? 15 : 20
  }) : k;
  return _react["default"].createElement("button", (0, _extends2["default"])({
    className: (0, _classnames["default"])(_button.DEFAULT, TYPE_STYLES_MAP[h], (b = {}, (0, _defineProperty2["default"])(b, _button.DISABLED, c || e), (0, _defineProperty2["default"])(b, _button.INVERTED_DISABLED, (c || e) && j), (0, _defineProperty2["default"])(b, "button-busy", e), (0, _defineProperty2["default"])(b, _button.SMALL, i), b), d),
    type: "button"
  }, (0, _lodash["default"])(a, OMITTED_PROPS), {
    disabled: e || c
  }), e ? _react["default"].createElement(_Icon["default"], {
    name: "shootstagrad",
    color: "white",
    spin: !0
  }) : [l, f]);
}

Button.defaultProps = {
  disabled: !1,
  className: "",
  busy: !1,
  children: null,
  small: !1
};

var _default = (0, _react.memo)(Button);

exports["default"] = _default;